import { Count_Products_By, Event_Targeting_Condition_Operator } from '@occc/graphql';

import { qualifiedEventsInitialFormValues } from './constants';

import { convertDateConditionToInitialFormValues } from './convertDateConditionToInitialFormValues';
import { mapQualifiedEventPurchaseConditionToOperator } from './mapQualifiedEventPurchaseConditionToOperator';
import {
  FulfilledLoyaltyEventQualifiedEventsInitialFormValues,
  MadePurchaseQualifiedEventsInitialFormValues,
  QualifiedEventAttribute,
  QualifiedEventsFormValues,
  QualifiedEventsInitialFormValues,
  QualifiedEventType,
} from '../../types';

export const convertQualifiedEventsToFormInitialValues = (
  qualifiedEvents: QualifiedEventAttribute[],
): QualifiedEventsInitialFormValues[] => {
  if (qualifiedEvents?.length === 0) {
    return [
      {
        ...qualifiedEventsInitialFormValues,
      },
    ];
  }

  return qualifiedEvents
    .map((event) => {
      if (!event?.audienceEventDateCondition) {
        return null;
      }
      const dateCondition = event.audienceEventDateCondition;

      if (
        !dateCondition.timeWindow &&
        !dateCondition.relativeMonthBack &&
        !dateCondition.fixedDateRange
      ) {
        return null;
      }

      const dateConditions = convertDateConditionToInitialFormValues({
        relativeMonthsBack: dateCondition.relativeMonthBack?.relativeMonthsBack,
        startDate: dateCondition.fixedDateRange?.startDate,
        endDate: dateCondition.fixedDateRange?.endDate,
        timeWindow: dateCondition.timeWindow?.timeWindow,
      });

      if (event.loyaltyEvent) {
        const value: FulfilledLoyaltyEventQualifiedEventsInitialFormValues = {
          event: QualifiedEventType.FulfilledLoyaltyEvent,
          loyaltyEvent: event.loyaltyEvent,
          times: event.times,
          timesOperator: event.operator || Event_Targeting_Condition_Operator.IsEqualTo,
          ...dateConditions,
        };
        return value;
      }

      if (event.purchaseCondition) {
        const value: MadePurchaseQualifiedEventsInitialFormValues = {
          event: QualifiedEventType.MadePurchase,
          times: event.times,
          timesOperator: event.operator || Event_Targeting_Condition_Operator.IsEqualTo,
          productGroups: event.purchaseCondition.productGroups ?? [],
          countProductsBy: event.purchaseCondition.countProductsBy ?? Count_Products_By.MoneyAmount,
          threshold: event.purchaseCondition.threshold ?? 0,
          locations: event.purchaseCondition.locations ?? [],
          operator: mapQualifiedEventPurchaseConditionToOperator(event.purchaseCondition),
          locationGroups: event.purchaseCondition.locationGroups ?? [],
          ...dateConditions,
        };

        return value;
      }

      return null;
    })
    .filter((value): value is QualifiedEventsFormValues => !!value);
};
